export default __webpack_public_path__ + "static/media/courses.000ba614.png";